import { Component, OnInit } from '@angular/core';
import { PrincipalDasboardLibService } from '../principal-dasboard-lib.service';

@Component({
  selector: 'lib-detailedview',
  templateUrl: './detailedview.component.html',
  styleUrls: ['./detailedview.component.scss'],
})
export class DetailedviewComponent implements OnInit {
  userMetadata: any;
  resourseMetadata: any;
  deatilViewContainer: any;
  deatilViewTable: any;
  closeButton: any;
  getTotalData:any
  userMetadataHeadingArray = [
    'Name:',
    'Start Time:',
    'Subject:',
    'End Time:',
    'Room Details:',
  ];
  resourseMetadataHeadingArray = [
    'Subject',
    'Class',
    'Chapter Name',
    'Topic Name',
    'Assets Details',
  ];
  constructor(private pdService: PrincipalDasboardLibService) {}

  ngOnInit(): void {
    this.deatilViewContainer = document.getElementById('pd-deatilViewContainer');
    this.deatilViewTable = document.getElementById('pd-deatilViewTable');
    this.closeButton = document.getElementById('pd-closeButton');
   
    this.pdService.detailedviewData.subscribe((data) => {
      this.createTable(data.userDetails);
      this.createResourcesTable(data.resourceDetails);
    });
  
    this.deatilViewContainer.style.display = 'none';
  }
  createTable(userMetadata: any) {
    this.deatilViewContainer.style.display = 'block';
    while (this.deatilViewTable.firstChild) {
      this.deatilViewTable.removeChild(this.deatilViewTable.lastChild);
    }

    let labelArray = new Array();
    let cnt = 0;
    for (let i = 0; i < userMetadata.length; i++) {
      let label = document.createElement('label');
      label.appendChild(
        document.createTextNode(this.userMetadataHeadingArray[i])
      );
      labelArray.push(label);
      let data = document.createElement('label');
      data.appendChild(document.createTextNode(userMetadata[i]));
      labelArray.push(data);
    }
    let tbl = document.createElement('table');
    tbl.id = "userDataTable";
    tbl.className = "table table-bordered";
    let tblBody = document.createElement('tbody');
    for (let j = 0; j < userMetadata.length / 2; j++) {
      let row = document.createElement('tr');
      let cell: any;
      for (let i = 0; i < 4; i++) {
        if (i % 2 == 0) {
          cell = document.createElement('th');
          cell.style['font-weight'] = "bold"
          // cell.style.background ="#e0e0e0";
        } else {
          cell = document.createElement('td');
        }
        if (cnt < labelArray.length) {
          cell.appendChild(labelArray[cnt]);
          row.appendChild(cell);
        }
        cnt++;
      }
      tblBody.appendChild(row);
      tbl.appendChild(tblBody);
      this.deatilViewTable.appendChild(tbl);
    }
  }
  createResourcesTable(resoureMetadata: any) {
    let labelArray = new Array();
    let cnt = 0;
    for (let i = 0; i < this.resourseMetadataHeadingArray.length; i++) {
      let label = document.createElement('label');
      label.appendChild(
        document.createTextNode(this.resourseMetadataHeadingArray[i])
      );
      labelArray.push(label);
    }
    for (let i = 0; i < resoureMetadata.length; i++) {
      for (let j = 0; j < 5; j++) {
        let label = document.createElement('label');
        label.appendChild(document.createTextNode(resoureMetadata[i][j]));
        labelArray.push(label);
      }
    }
    let tbl = document.createElement('table');
    tbl.className = "table table-bordered";
    tbl.id = "resoureMetadataTable";
    let tblBody = document.createElement('tbody');
    for (let j = 0; j <= resoureMetadata.length; j++) {
      let row = document.createElement('tr');
      let cell: any;
      for (let i = 0; i < 5; i++) {
        if (j == 0) {
          cell = document.createElement('th');
          cell.style['font-weight'] = 'bold';
          // cell.style.background ="#e0e0e0";
        } else {
          cell = document.createElement('td');
        }

        if (cnt < labelArray.length) {
          cell.appendChild(labelArray[cnt]);
          row.appendChild(cell);
        }
        cnt++;
      }
      tblBody.appendChild(row);
      tbl.appendChild(tblBody);
      this.deatilViewTable.appendChild(tbl);
    }
  }
 
  onCloseBtnClick() {
    this.deatilViewContainer.style.display = 'none';
  }
}
